import { SegmentsAudioPlaybackProvider } from '@app/core/playback/audio/SegmentsAudioPlaybackProvider';
import { useStation } from '@app/core/stations/hooks/useStation';
import { isDiarizationFragmentsEnabled } from '@app/modules/fragments/helpers/is-transcription-enabled';
import { ReactNode } from 'react';
import { useFragmentCtx } from '../../../context/fragment-ctx';
import { TranscriptionView } from '../../transcription/TranscriptionView';
import { AudioFragmentChunksList } from './AudioFragmentChunksList';

/**
 * Main component that renders the audio player for fragments.
 * Provides a shared SegmentsAudioPlaybackProvider for both:
 * - ChunkPlayer components (which detect and reuse this parent context)
 * - TranscriptionView (which needs playback hooks for sync/highlighting)
 * When children are provided, renders the provider and children only (no default chunks/transcription).
 * When no children, renders chunks list and transcription below it.
 */
export function AudioFragmentMedia(props: { children?: ReactNode }) {
  const { children } = props;
  const fragment = useFragmentCtx();
  const station = useStation(fragment.stationId);

  const content = children ?? (
    <>
      <AudioFragmentChunksList />
      {isDiarizationFragmentsEnabled(station) && (
        <div style={{ marginTop: '1rem' }}>
          <TranscriptionView fragmentId={fragment.id} />
        </div>
      )}
    </>
  );

  return <SegmentsAudioPlaybackProvider station={station}>{content}</SegmentsAudioPlaybackProvider>;
}
